var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactInfoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77509",
    "data-name": "Path 77509",
    d: "M110,28a12,12,0,1,0,12,12A12.012,12.012,0,0,0,110,28Zm0,1.6A10.4,10.4,0,1,1,99.6,40,10.388,10.388,0,0,1,110,29.6Zm-.267,4.8a1.067,1.067,0,1,0,1.067,1.067A1.067,1.067,0,0,0,109.733,34.4Zm-1.15,2.667a.8.8,0,1,0,.083,1.6h.533V44h-.533a.778.778,0,0,0-.083,0,.8.8,0,1,0,.083,1.6h2.667a.8.8,0,1,0,0-1.6H110.8V37.867a.8.8,0,0,0-.8-.8h-1.333c-.028,0-.056,0-.083,0Z",
    transform: "translate(-98 -28)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfoDark);
export default __webpack_public_path__ + "static/media/contactInfoDark.1f12be251090b24f90426e1127144794.svg";
export { ForwardRef as ReactComponent };